import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { CONTROL } from '../../../../components';
import { generateCpuItems, generateRamItems, getDisk, getEip, getObs } from '../../../utils';
var BdInstanceTypeItem = {
  Single: 'Single',
  PrimaryStandby: 'Primary/Standby'
};
var bdInstanceTypeItems = [{
  value: BdInstanceTypeItem.Single,
  label: 'Single'
}, {
  value: BdInstanceTypeItem.PrimaryStandby,
  label: 'Primary/Standby'
}];
var CpuRamMap = {
  '1': [2, 4],
  '2': [4, 8, 16],
  '4': [8, 16, 32],
  '8': [16, 32, 64],
  '16': [32, 64, 128],
  '32': [64, 128],
  '64': [128, 256, 512]
};
var getRdsControls = function getRdsControls(_ref) {
  var prefix = _ref.prefix;
  return {
    cpu: {
      type: CONTROL.Segmented,
      accessorKey: "".concat(prefix, ".cpu"),
      defaultValue: '1',
      items: generateCpuItems([1, 2, 4, 8, 16, 32, 64]),
      decoratorProps: {
        label: 'Количество vCPU',
        labelTooltip: 'Виртуальный процессор'
      }
    },
    ram: {
      type: CONTROL.Segmented,
      accessorKey: "".concat(prefix, ".ram"),
      defaultValue: '2',
      items: generateRamItems(CpuRamMap['1']),
      decoratorProps: {
        label: 'Объём RAM',
        labelTooltip: 'Оперативная память'
      },
      watchedControls: {
        cpu: "".concat(prefix, ".cpu")
      },
      relateFn: function relateFn(_ref2) {
        var cpu = _ref2.cpu;
        var items = CpuRamMap[cpu] || [];
        return {
          items: generateRamItems(items)
        };
      }
    },
    bdQuantity: {
      type: CONTROL.Stepper,
      accessorKey: "".concat(prefix, ".bdQuantity"),
      defaultValue: 1,
      decoratorProps: {
        label: 'Количество RDS'
      },
      uiProps: {
        min: 1,
        max: 50,
        postfix: 'Шт'
      }
    }
  };
};
var rds = getRdsControls({
  prefix: 'rds'
});
var bdReplicaRds = getRdsControls({
  prefix: 'bdReplica.rds'
});
export var MYSQL_DATA_BASE_FORM_CONFIG = {
  ui: [['rdsBdInstanceType'], 'bdInstanceAlert', ['rdsCpu', 'rdsRam'], ['evs', 'rdsBdQuantity'], 'eip', 'bdReplica', ['obs']],
  controls: {
    rdsBdInstanceType: {
      type: CONTROL.Segmented,
      accessorKey: 'rds.bdInstanceType',
      items: bdInstanceTypeItems,
      defaultValue: BdInstanceTypeItem.Single,
      decoratorProps: {
        label: 'Режим развертывания'
      }
    },
    bdInstanceAlert: {
      type: 'alert',
      uiProps: {
        appearance: 'info',
        description: 'Данный режим подразумевает развертывание на двух инстансах — Primary и Standby. Конфигурация инстанса Primary дублируется для инстанса Standby. Стоимость в чеке указывается за 2 инстанса',
        outline: true,
        visible: false
      },
      accessorKey: 'instances',
      watchedControls: {
        bdInstanceType: 'rds.bdInstanceType'
      },
      relateFn: function relateFn(_ref3) {
        var bdInstanceType = _ref3.bdInstanceType;
        if (bdInstanceType === BdInstanceTypeItem.PrimaryStandby) {
          return {
            uiProps: {
              visible: true
            }
          };
        }
      }
    },
    bdReplica: {
      type: CONTROL.Object,
      ui: ['replica'],
      visible: true,
      controls: {
        replica: {
          type: CONTROL.ToggleObject,
          switchKey: 'bdReplicaIsNeeded',
          decoratorProps: {
            label: 'Реплика базы данных',
            labelTooltip: 'Тип сервера реплики равен типу сервера базы данных'
          },
          control: {
            type: CONTROL.Object,
            ui: [['cpu', 'ram'], ['systemDisk', 'bdQuantity']],
            controls: {
              cpu: _objectSpread(_objectSpread({}, bdReplicaRds.cpu), {}, {
                decoratorProps: _objectSpread(_objectSpread({}, bdReplicaRds.cpu.decoratorProps), {}, {
                  labelTooltip: 'Количество vCPU реплики рекомендуется выбирать равное количеству основного RDS'
                })
              }),
              ram: _objectSpread(_objectSpread({}, bdReplicaRds.ram), {}, {
                decoratorProps: _objectSpread(_objectSpread({}, bdReplicaRds.ram.decoratorProps), {}, {
                  labelTooltip: 'Объем RAM реплики рекомендуется выбирать равное количеству основного RDS'
                })
              }),
              bdQuantity: _objectSpread(_objectSpread({}, bdReplicaRds.bdQuantity), {}, {
                accessorKey: 'bdReplica.replicaQuantity',
                decoratorProps: {
                  label: 'Количество реплик'
                },
                uiProps: {
                  min: 1,
                  max: 5,
                  postfix: 'Шт'
                }
              }),
              systemDisk: getDisk({
                space: {
                  accessorKey: 'bdReplica.evs.systemDisk.diskSpace',
                  defaultValue: 40,
                  uiProps: {
                    min: 40,
                    max: 4000,
                    disabled: true
                  },
                  decoratorProps: {
                    labelTooltip: 'SSD имеют высокую скорость передачи данных, что в два раза быстрее, чем HDD-накопители'
                  }
                },
                specification: {
                  accessorKey: 'bdReplica.evs.systemDisk.specification',
                  defaultValue: 'SAS',
                  uiProps: {
                    disabled: true
                  }
                }
              }),
              // Hidden
              replicaQuantity: {
                type: CONTROL.Stepper,
                accessorKey: 'bdReplica.rds.bdQuantity',
                defaultValue: 1,
                decoratorProps: {
                  label: ''
                },
                uiProps: {
                  visible: false
                }
              },
              // Hidden
              evsAdditionalDisks: {
                type: 'select-multiple',
                accessorKey: 'bdReplica.evs.additionalDisks',
                items: [],
                defaultValue: [],
                uiProps: {
                  visible: false
                },
                decoratorProps: {
                  label: ''
                }
              }
            }
          }
        }
      }
    },
    rdsCpu: _objectSpread(_objectSpread({}, rds.cpu), {}, {
      onChangeFn: function onChangeFn(value, setValue) {
        setValue([['rds.cpu', value], ['bdReplica.rds.cpu', value]]);
      }
    }),
    rdsRam: _objectSpread(_objectSpread({}, rds.ram), {}, {
      onChangeFn: function onChangeFn(value, setValue) {
        setValue([['rds.ram', value], ['bdReplica.rds.ram', value]]);
      }
    }),
    rdsBdQuantity: rds.bdQuantity,
    evs: getDisk({
      space: {
        accessorKey: 'evs.systemDisk.diskSpace',
        defaultValue: 40,
        uiProps: {
          min: 40,
          max: 4000
        },
        decoratorProps: {
          labelTooltip: 'SSD имеют высокую скорость передачи данных, что в два раза быстрее, чем HDD-накопители'
        },
        onChangeFn: function onChangeFn(value, setValue) {
          setValue([['evs.systemDisk.diskSpace', value], ['bdReplica.evs.systemDisk.diskSpace', value]]);
        }
      },
      specification: {
        accessorKey: 'evs.systemDisk.specification',
        defaultValue: 'SAS',
        onChangeFn: function onChangeFn(value, setValue) {
          setValue([['evs.systemDisk.specification', value], ['bdReplica.evs.systemDisk.specification', value]]);
        }
      }
    }),
    eip: getEip({
      trafficKey: 'eip.traffic'
    }),
    obs: getObs({
      space: {
        accessorKey: 'obs.storage.space',
        defaultValue: 0
      },
      units: {
        accessorKey: 'obs.storage.unitsOfCalculation'
      }
    }),
    // Hidden
    evsAdditionalDisks: {
      type: 'select-multiple',
      accessorKey: 'evs.additionalDisks',
      items: [],
      defaultValue: [],
      uiProps: {
        visible: false
      },
      decoratorProps: {
        label: ''
      }
    },
    // Hidden
    ipQuantity: {
      accessorKey: 'eip.ipQuantity',
      type: CONTROL.Stepper,
      defaultValue: 0,
      decoratorProps: {},
      uiProps: {
        visible: false
      }
    }
  }
};